var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};

//Jquery
	$(document).ready(function(){
		//Menu_hover Primary
		$("ul#utility_navigation_primary > li").mouseover(function(){
			$(this).addClass("myactive");
		});
		$("ul#utility_navigation_primary > li").mouseout(function(){
			$(this).removeClass("myactive");
		});
    $('.mega_menu_container').hover(
      function() {
        $('html').toggleClass('lock');
        $(this).toggleClass('hover');
      }
    )
    $('.mega_menu_simple_container.has-submenu').hover(
      function(){
        $(this).toggleClass('hover');
      }
    )
    $('.wsmenu.clearfix.multi-drop.secondary-menu .has-submenu').hover(
      function() {
        $('.wsmenu.clearfix.multi-drop.secondary-menu .has-submenu').toggleClass('hover')
      }
    )
		
				//Menu_hover secondary
		$("ul#utility_navigation_secondary > li").mouseover(function(){
			$(this).addClass("myactive");
		});
		$("ul#utility_navigation_secondary > li").mouseout(function(){
			$(this).removeClass("myactive");
		});
		
				//Menu_hover myprofile
		$("ul#utility_navigation_myprofile > li").mouseover(function(){
			$(this).addClass("myactive");
		});
		$("ul#utility_navigation_myprofile > li").mouseout(function(){
			$(this).removeClass("myactive");
		});
		
		// == FAM Tool ==
			$(".componet_fam_tool").click(function(){
				$(".component_banner").toggleClass("fam_active");
				$(".laco_marker_tool").toggleClass("fam_active");
			});
      
//       $('.markal-category-slider').owlCarousel({
//         loop:true,
//         margin:0,
//         stagePadding: 70,
//         nav:true,
//         dots: false,
//         responsiveClass:true,
//         responsive:{
//             0:{
//                 items:1,
//                 stagePadding: 0
//             },
//             601:{
//                 items:3
//             }
//         }
//       })
			
			// banner hover images changes
			$(".compact_lister li").mouseover(function(){
				 var imageUrl1 = $(this).children('img').attr('src');
				$('#component_npm').attr('src', imageUrl1);
			});
				 
				 
				 
				 $('.compact_lister li').mouseenter(function() {
					if (!$(this).hasClass('myactive')){
						$('.compact_lister li').removeClass('myactive');
						$(this).addClass('myactive');
					}
				});
      
								 
	  $('#shopify-section-header #wsnavtoggle').click(function(){
        $("#nav .menu-wrapper").toggleClass('active');
        $("#nav .navbar").toggleClass('active');
      });
      $('#search-toggle').click(function(){
        $('.mobile-landscape-search').addClass('active');
      });
      $('#close-search').click(function(){
        $('.mobile-landscape-search').removeClass('active');
      });
      $(".Fit_sect a").click(function(){
        var target_id = '#' + $(this).data('target') + '-faq';
        $('.topic-content > div').each(function(){
          $(this).removeClass('active');
        });
        $(target_id).addClass('active');
      });
//       $(".about_listbody li a").click(function(){
//         if($(this).data('target')) {
//           $('.tab-edu').removeClass('hidden');
//           $('.tab-pdf').addClass('hidden');
//           var target_class = '.' + $(this).data('target');
//           $('.edu-pane').each(function(){
//             $(this).removeClass('active');
//           });
//           $(target_class).addClass('active');
//         } else {
//           $('.tab-pdf').removeClass('hidden');
//           $('.tab-edu').addClass('hidden');
//         }
//       });
//       $("#edu_brand_link").click(function(){
//         $('.tab-edu').removeClass('hidden');
//         $('.tab-pdf').addClass('hidden');
//         var target_class = '.' + $(this).data('target');
//         $('.edu-pane').each(function(){
//           $(this).removeClass('active');
//         });
//         $(target_class).addClass('active');
//       });
      
      /* wish list */
      $('div.sa_wishlist_page').wrap('<div id="content"><div class="container"></div></div>');
      $( '<ol class="breadcrumb"><li><a href="/" title="Home">Home</a></li><li>Account</li></ol>').insertBefore($('div.sa_wishlist_page'));
      
      /* product minimum qty */
      $('.qty_price_wrapper .minus_btn').click(function(){
        var val = parseInt($('.qty_price_wrapper #quantity').val(), 10);
        var min = parseInt($('.qty_price_wrapper #quantity').attr('min'), 10);
        if (val <= min)
          $('.qty_price_wrapper #quantity').val(min+1);
      });
      
      
      /* Sample Request - checkbox limit 3 */
//       $('input.market_type').on('change', function(evt) {
//         if($('input.market_type:checked').length >= 4) {
//           this.checked = false;
//         }
//       });
      
      /* Request a sample - Submit */
      $("#request-a-sample input.btn-laco-primary").click(function() {
        
      });
      
      $('input[title="Add to Cart"]').delay(5000).replaceWith('<a href="/pages/find-a-seller/" class="find-seller-btn">Find a Seller</a>');
      
      if(getUrlParameter('content')){
        var content = getUrlParameter('content');
        $('.tab-edu').removeClass('hidden');
        $('.tab-pdf').addClass('hidden');
        var target_class = '.' + content + '_section';
        $('.edu-pane').each(function(){
          $(this).removeClass('active');
        });
        $(target_class).addClass('active');
      } else {
        $('.tab-pdf').removeClass('hidden');
        $('.tab-edu').addClass('hidden');
      }            
      
      /* Temperature replace å¡ to ° */
      $('#specifications .custom-field--value li').text(function () {
    	return $(this).text().replace(/å¡/g, "°"); 
      });
      $('.laco_related_desc .product-tagline').text(function () {
    	return $(this).text().replace(/å¡/g, "°"); 
      });
      
      //See more surface
      $('#lacodemo #megamenu_items-surfaces .link-list:last-child').click(function() {
        if ($('.component_banner').hasClass('fam_active') == false) {
          $('.component_banner').addClass('fam_active');
          $('.laco_marker_tool').addClass('fam_active');
          $('.mega_menu_container.hover').removeClass('hover');
          $('.laco_marker_tool').focus();
        }
      });
      $('#tempil #megamenu_items-surfaces .link-list:last-child').click(function() {
        if ($('.component_banner').hasClass('fam_active') == false) {
          $('.component_banner').addClass('fam_active');
          $('.laco_marker_tool').addClass('fam_active');
          $('.mega_menu_container.hover').removeClass('hover');
          $('.laco_marker_tool').focus();
        }
      });
      $('#la-co #megamenu_items-surfaces .link-list:last-child').click(function() {
        if ($('.component_banner').hasClass('fam_active') == false) {
          $('.component_banner').addClass('fam_active');
          $('.laco_marker_tool').addClass('fam_active');
          $('.mega_menu_container.hover').removeClass('hover');
          $('.laco_marker_tool').focus();
        }
      }); 
      $('#all-weather #megamenu_items-surfaces .link-list:last-child').click(function() {
        if ($('.component_banner').hasClass('fam_active') == false) {
          $('.component_banner').addClass('fam_active');
          $('.laco_marker_tool').addClass('fam_active');
          $('.mega_menu_container.hover').removeClass('hover');
          $('.laco_marker_tool').focus();
        }
      });       
      $('#tempilink #megamenu_items-surfaces .link-list:last-child').click(function() {
        if ($('.component_banner').hasClass('fam_active') == false) {
          $('.component_banner').addClass('fam_active');
          $('.laco_marker_tool').addClass('fam_active');
          $('.mega_menu_container.hover').removeClass('hover');
          $('.laco_marker_tool').focus();
        }
      }); 
      
      /* Europe Only Logic */
      $('#SingleOptionSelector-0').change(function() {
        if ($(this).find(':selected').hasClass('europe')) {
          if (!$(this).parent().hasClass('europe')) {
            $(this).parent().removeClass('non-europe');
            $(this).parent().addClass('europe');
            if(!$('.main-product-select.europe + .selector-wrapper.main-product-select').find(':selected').hasClass('europe'))
            {
              $('.main-product-select.europe + .selector-wrapper.main-product-select option').eq($('.main-product-select.europe + .selector-wrapper.main-product-select option.europe').index()).prop('selected', true);
            }
          }
        }
        else {
          if (!$(this).parent().hasClass('non-europe')) {
            $(this).parent().removeClass('europe');
            $(this).parent().addClass('non-europe');
            if(!$('.main-product-select.non-europe + .selector-wrapper.main-product-select').find(':selected').hasClass('non-europe'))
            {
              $('.main-product-select.non-europe + .selector-wrapper.main-product-select option').eq($('.main-product-select.non-europe + .selector-wrapper.main-product-select option.non-europe').index()).prop('selected', true);
            }
          }
        }
      }); 
      
      /* Temperature Logic */
      $('.single-option-selector').change(function() {
        if ($(this).find(':selected').hasClass('fahrenheit')) {
          if ($(this).parent().hasClass('celsious')) {
            $(this).parent().removeClass('celsious');
            $(this).parent().addClass('fahrenheit');
            if($('.main-product-select.fahrenheit + .selector-wrapper.main-product-select').find(':selected').hasClass('celsious'))
            {
              $('.main-product-select.fahrenheit + .selector-wrapper.main-product-select option').eq($('.main-product-select.fahrenheit + .selector-wrapper.main-product-select option.fahrenheit').index()).prop('selected', true);
            }
          }
        }
        else {
          if ($(this).parent().hasClass('fahrenheit')) {
            $(this).parent().removeClass('fahrenheit');
            $(this).parent().addClass('celsious');
            if($('.main-product-select.celsious + .selector-wrapper.main-product-select').find(':selected').hasClass('fahrenheit'))
            {
              $('.main-product-select.celsious + .selector-wrapper.main-product-select option').eq($('.main-product-select.celsious + .selector-wrapper.main-product-select option.celsious').index()).prop('selected', true);
            }
          }
        }
      });

      /* Thumbnail Image Click - SKU change */
      thumbnails = $('img[src*="/products/"]').not(':first');
      if (thumbnails.length) {
        thumbnails.bind('click', function() {
          var arrImage = $(this).attr('src').split('?')[0].split('.');
          var strExtention = arrImage.pop();
          var strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/,'');
          var strNewImage = arrImage.join('.')+"."+strRemaining+"."+strExtention;
          if (typeof variantImages[strNewImage] !== 'undefined') {
            productOptions.forEach(function (value, i) {
            optionValue = variantImages[strNewImage]['option-'+i];
            if (optionValue !== null && $('.single-option-selector:eq('+i+') option').filter(function() { return $(this).text() === optionValue }).length) {
              $('.single-option-selector:eq('+i+')').val(optionValue).trigger('change');
            }
          });
        }
      });
      }

      /* Bundle Page */

      /* FAM Tool - responsive */
      if ($(window).width() <= 991)
      {
        $('.component_banner.fam_active').removeClass('fam_active');
        $('.laco_marker_tool.fam_active').removeClass('fam_active');
      }
      
      /* Hex, King Size, Fine Color */
      $('.single-option-selector').change(function() {
        if ($(this).val().indexOf('Hex Size') != -1) {
          $('.swatch-element.color').hide();
          $('.swatch-element.color.white').show();
          $('.swatch-element.color.yellow').show();
        }
        else if ($(this).val().indexOf('King Size') != -1) {
          $('.swatch-element.color').hide();
          $('.swatch-element.color.white').show();
        }
        else if ($(this).val().indexOf('Fine Size') != -1) {
          $('.swatch-element.color').hide();
          $('.swatch-element.color.white').show();
          $('.swatch-element.color.yellow').show();
        }
        else if ($(this).val().indexOf('Size') != -1) {
          $('.swatch-element.color').show();
        }
      });
 });

$(window).load(function() {
  /* Reset Button redirects to homepage */
  $('#ymm_reset').click(function(){
    window.location.href="/";
  });
  
  /* Show Breadcrumb */
  
  /* Wish List - Find a Seller Btn*/
  $('input[title="Add to Cart"]').delay(5000).replaceWith('<a href="/pages/find-a-seller/" class="find-seller-btn">Find a Seller</a>');
  
});
